import { Meta } from 'util/metaPath'
import { msg, RuleFunction } from 'util/validation'

export const igualA = <T>(compareKey: Meta<T>, inputName: string, compareName: string): RuleFunction => (
  inputValue,
  allValues
) => (allValues?.[compareKey.absolutePath()] !== inputValue ? msg('igualA', inputValue, inputName, compareName) : null)
